module.exports = __webpack_public_path__ + "static/media/7_evenement.7768ab10.jpg";